export const TOGGLE_CONFIRM_DIALOG =
  'ipfabric/ConfirmDialog/TOGGLE_CONFIRM_DIALOG';
export const CLOSE_CONFIRM_DIALOG =
  'ipfabric/ConfirmDialog/CLOSE_CONFIRM_DIALOG';
